import { GlassmorphismContainer } from "../GlassmorphismContainer/GlassmorphismContainer";
import { useAppSelector } from "../../store/hooks";
import styled from "styled-components";
import { NavButton } from "../NavButton/NavButton";

const ToastContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
`;

const CloseButtonWrapper = styled.div`
  margin-right: 0.5rem;
  flex-shrink: 0;
`;

const ToastMessage = styled.span`
  flex: 1;
  min-width: 0;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 700;
  word-wrap: break-word;
  overflow-wrap: break-word;
  line-height: 125%;
`;

export const GlassmorphismToast = ({
  message,
  closeToast,
}: {
  message: string;
  closeToast: () => void;
}) => {
  const contrast = useAppSelector((state) => state.userInfo.contrast);

  return (
    <GlassmorphismContainer
      padding="0.5rem"
      borderRadius="32rem"
      hasBorder
      contrast={contrast}
      flexDirection="row"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <ToastContent>
        <CloseButtonWrapper onClick={(e) => e.stopPropagation()}>
          <NavButton size="2.625rem" onClick={closeToast} button="exit" />
        </CloseButtonWrapper>
        <ToastMessage>{message}</ToastMessage>
      </ToastContent>
    </GlassmorphismContainer>
  );
};
